// @flow

import styled from 'styled-components';
import { PageContainer as BasePageContainer } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/controller.styles';

export const PageContainer = styled(BasePageContainer)`
  display: flex;
  flex-direction: column;
`;
